export default "__VITE_ASSET__DSoRIp6I__"